// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lViKZWqiCpguCX8Gnat5.t6DsVmkKoFd2ClgPxg7k{padding:0;background:none;color:#000 !important;cursor:pointer;font-size:12px;font-weight:normal}`, "",{"version":3,"sources":["webpack://./src/components/buttons/navigation/ReturnButton/styles.module.sass"],"names":[],"mappings":"AAAA,2CACE,SAAA,CACA,eAAA,CACA,qBAAA,CACA,cAAA,CACA,cAAA,CACA,kBAAA","sourcesContent":[".button.current\n  padding: 0\n  background: none\n  color: #000 !important\n  cursor: pointer\n  font-size: 12px\n  font-weight: normal\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `lViKZWqiCpguCX8Gnat5`,
	"current": `t6DsVmkKoFd2ClgPxg7k`
};
export default ___CSS_LOADER_EXPORT___;
